import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { ErrorMessage } from '../components/ErrorMessage';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { needed } from './labels';

// DocumentRequestPanel: Stand der Objektunterlagen am Lead bzw. Termin mit Weg in den Unterlagen-Konfigurator.
export function DocumentRequestPanel({ leadId, embedded = false }: { leadId: string; embedded?: boolean }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const q = useQuery({
    queryKey: projectKeys.documentRequest(project.id, leadId),
    queryFn: ({ signal }) => papi.documentRequest(leadId, signal),
  });
  const to = `/p/${project.key}/leads/${leadId}/unterlagen`;
  const req = q.data;
  const items = req?.items.filter(needed) ?? [];
  const received = items.filter((i) => i.status === 'RECEIVED').length;
  const requested = items.filter((i) => i.status === 'REQUESTED').length;
  return (
    <section className={embedded ? 'doc-area-row' : 'card'} aria-labelledby={`unterlagen-${leadId}`}>
      <div className="section-head">
        {embedded ? <h3 id={`unterlagen-${leadId}`}>Unterlagen</h3> : <h2 id={`unterlagen-${leadId}`}>Unterlagen</h2>}
        <Link to={to} className={embedded ? 'btn btn-small' : 'btn btn-primary btn-small'}>
          {req?.saved ? 'Öffnen' : can('document.edit') ? 'Unterlagen zusammenstellen' : 'Ansehen'}
        </Link>
      </div>
      {q.isError && <ErrorMessage error={q.error} onRetry={() => void q.refetch()} />}
      {req && !req.saved && (
        <p className="muted">
          Noch nicht zusammengestellt. Maklerpass schlägt die Unterlagen für das Objekt vor, mit zuständiger Stelle, Weg und Gebühr
          {req.region_supported ? ` (${req.region})` : ''}.
        </p>
      )}
      {req?.saved && (
        <p>
          {received} von {items.length} Unterlagen da · {requested} angefordert · {items.length - received - requested} offen
          {req.power_of_attorney ? ' · Vollmacht liegt vor' : ''}
        </p>
      )}
    </section>
  );
}
